import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { isKosherUser, elementaryStudentOrTeacher } from "../../../../utils/utils";
import Menu from '../../../ui/menu/Menu'
import pathRouts from "../../../../enums/pathRoute";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import useLevels from "../../../../hooks/useLevelsBar";
import classes from "./MenuMobile.module.css"

const MenuMobile = ({ id }) => {

    const { texts } = useSelector(state => state.translate);
    const { user, userDetails, isStudent } = useSelector(state => state.auth);
    const levels = useLevels();

    return (
        <div className={classes.MenuMobile}>
            <Menu colorSeclect="#94268F" color="#606060" activeClass={classes.ActiveClass} id={id} >
                {(!isKosherUser(userDetails) && elementaryStudentOrTeacher(user, userDetails, isStudent)) &&
                    <Link
                        to={pathRouts.CHATALBERT.route}
                        baseName={pathRouts.CHATALBERT.baseName}>
                        <div className={classes.MenuMobileLink} aria-label={texts.trainingCamp}>
                            <div className={classes.Line} />
                            <Icon name={iconsList.chat} size="32px" />
                        </div>
                    </Link>}

                <Link to={pathRouts.HOME.route}>
                    <div className={classes.MenuMobileLink} aria-label={texts.homePage}>
                        <div className={classes.Line} />
                        <Icon name={iconsList.map} />
                    </div>
                </Link>

                <Link to={pathRouts.CURATORSHIP.route}>
                    <div className={classes.MenuMobileLink} aria-label={texts.curatorship}>
                        <div className={classes.Line} />
                        <Icon name={iconsList.digitalCuratorship} />
                    </div>
                </Link>
            </Menu>
        </div>
    )
}

export default MenuMobile;